import React from 'react';
import { Clock, Globe, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export const About = () => {
  return <section id="about" className="py-20 bg-white dark:bg-gray-900 transition-colors" data-id="element-16">
      <div className="container mx-auto px-4 md:px-6" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-19">
            About Me
          </h2>
          <div className="w-20 h-1 bg-indigo-600 dark:bg-indigo-400 mx-auto" data-id="element-20"></div>
        </motion.div>
        <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-21">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="md:w-2/5" data-id="element-22">
            <div className="relative" data-id="element-23">
              <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.2
            }} className="absolute -top-4 -left-4 w-full h-full border-2 border-indigo-600 dark:border-indigo-400 rounded-lg z-0" data-id="element-24"></motion.div>
              <motion.img whileHover={{
              scale: 1.02
            }} transition={{
              duration: 0.3
            }} src="https://uploadthingy.s3.us-west-1.amazonaws.com/rnk8rZ5Tyk8xcGpbNeNaVD/IMG_8552.png" alt="Multiple Dredget app screens showing various features" className="rounded-lg shadow-md relative z-10 w-full h-auto object-cover" data-id="element-25" />
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="md:w-3/5" data-id="element-26">
            <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-27">
              Hi, I'm a creative designer, UX/UI and visual creator
            </h3>
            <p className="text-gray-600 dark:text-gray-200 mb-6" data-id="element-28">
              I have a strong background in print, digital design, and video
              production. My work bridges practical precision with visual
              thinking – from crafting user experiences and brand visuals to
              preparing production-ready files.
            </p>
            <div className="mb-6" data-id="element-29">
              <h4 className="font-bold mb-2 text-gray-900 dark:text-white" data-id="element-30">
                I have experience in:
              </h4>
              <ul className="list-disc pl-5 text-gray-600 dark:text-gray-200 space-y-2" data-id="element-31">
                <li data-id="element-32">UX/UI design (Figma, Webflow, user flows, prototypes)</li>
                <li data-id="element-33">Print production (digital print, prepress, cutting)</li>
                <li data-id="element-34">
                  Video editing & image modification (After Effects, Photoshop)
                </li>
              </ul>
            </div>
            <div className="mb-8" data-id="element-35">
              <h4 className="font-bold mb-2 text-gray-900 dark:text-white" data-id="element-36">
                Artistic Philosophy
              </h4>
              <p className="text-gray-600 dark:text-gray-200" data-id="element-37">
                I believe great design lives where form meets purpose — and
                every detail matters. I approach each project with curiosity and
                focus – to find a solution that works and looks great. My
                strength lies in transforming simple ideas into meaningful and
                aesthetic solutions that resonate both functionally and
                emotionally.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-38">
              {[{
              icon: Clock,
              label: '2+ Years',
              sublabel: 'Of Experience'
            }, {
              icon: Zap,
              label: '12+ Projects',
              sublabel: 'Completed'
            }, {
              icon: Globe,
              label: '6+ Clients',
              sublabel: 'Worldwide'
            }].map((stat, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.6 + index * 0.1
            }} whileHover={{
              y: -5,
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
            }} className="flex flex-col items-center p-4 bg-gray-50 dark:bg-gray-800 rounded-lg transition-colors" data-id="element-39">
                  <stat.icon className="text-indigo-600 dark:text-indigo-400 mb-2" size={28} data-id="element-40" />
                  <h4 className="font-bold text-gray-900 dark:text-white" data-id="element-41">
                    {stat.label}
                  </h4>
                  <p className="text-sm text-gray-500 dark:text-gray-300 text-center" data-id="element-42">
                    {stat.sublabel}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};